// src/pages/auth/EmailConfirmationPage.tsx
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useToast } from "../../util/ToastProvider";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../config/firebaseConfig";

export default function EmailConfirmationPage() {
  const [loading, setLoading] = useState(false);
  const useToaster = useToast();
  const location = useLocation();

  // Extract query params
  const params = new URLSearchParams(location.search);
  const email = params.get("email") || "";
  const type = params.get("type") || "verify"; // default to verify

  // ✅ Reusable resend handler
  async function resendEmail() {
    try {
      setLoading(true);
      const authUserHandler = httpsCallable(functions, "authUserHandler");

      const requestType = type === "reset" ? "resetPassword" : "resendVerification";
      const result: any = await authUserHandler({ type: requestType, email });

      if (result.data?.success) {
        useToaster.success(result.data.message || "Email sent again successfully.");
      } else {
        useToaster.error("Something went wrong while resending the email.");
      }
    } catch (err: any) {
      console.error("❌ Resend email failed:", err);
      useToaster.error(err.message || "Failed to resend email.");
    } finally {
      setLoading(false);
    }
  }

  // ✅ Conditional heading + description based on type
  const heading = type === "reset" ? "Email sent" : "Awaiting confirmation";
  const description =
    type === "reset"
      ? `A password reset link has been sent to ${email}. Please click on it within an hour.`
      : `A confirmation email has been sent to ${email}. Please verify your account within an hour.`;
  const buttonText = type === "reset" ? "Resend the link" : "Resend confirmation";

  return (
    <div className="text-dark-text">

        <h1 className="text-[20px] font-medium mb-2">{heading}</h1>

        <p className="text-[14px] font-normal mb-6">{description}</p>

        <button
          onClick={resendEmail}
          disabled={loading}
          className="w-full rounded-xl bg-indigo-600 px-4 py-2.5 text-white text-sm font-medium 
                     hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Resending..." : buttonText}
        </button>

        <div className="mt-6 text-sm text-white">
          {type === "reset" ? (
            <>
              Don’t want to reset your password?{" "}
              <a href="/auth/login" className="underline">
                Sign in
              </a>
            </>
          ) : (
            <>
              Already verified your email?{" "}
              <a href="/auth/login" className="underline">
                Sign in
              </a>
            </>
          )}
        </div>
    </div>
  );
}
